import Loadable from '../../components/loadable';

const EventDefaultsList = Loadable({
  loader: () => import('../../pages/event_defaults/event_defaults_list'),
});

angular.module('gym').value('EventDefaultsList', EventDefaultsList);
